class ExpandState {

	constructor() {
		this.states = []
	}

	set(id, state) {
		for(let s of this.states) {
			if (s.id === id) {
				s.state = state
				return
			}
		}
		this.states.push({
			id: id,
			state: state,
		})
	}

	get(id) {
		for(let s of this.states) {
			if (s.id === id) {
				return s.state
			}
		}
		return false
	}

	updateTree(tree) {
		if (tree) {
			for(let item of tree) {
				if (item.type.toString() === "0") {
					item.expand = this.get(item.id)
					this.updateTree(item.items)
				}
			}
		}
	}

}

export default ExpandState
